"use strict";

/**
 * Redimensionner automatiquement les logos client, une fois chargés, en partant
 * d'une taillecarrée pour arriver à une taille respectant le ratio "naturel" de
 * l'image, en gardant la même hauteur et en ajustant la largeur et la position
 * à gauche pour rester centrée
 */
function autoPositionImage(img) {
	var self = $(img),
		position = self.position(),
		currentHeight = self.height(),
		currentWidth = currentHeight,
		newHeight = Math.min(currentHeight, img.naturalHeight),
		newWidth = Math.round(newHeight * img.naturalWidth / img.naturalHeight);

	self.css('width', newWidth + 'px').css('left', (position.left + currentWidth / 2 - newWidth / 2));
	self.css('height', newHeight + 'px').css('top', (position.top + currentHeight / 2 - newHeight / 2));
	self.css('visibility', 'visible');
}

function Gis(element, data) {

	/**
	 * Cette méthode centralise les appels vérifiant que la carte est suffisamment grande
	 */
	function getMapVisible(w, h) {
		return w >= 10 && h >= 10;
	}

	/**
	 * Cette fonction retourne un identifiant spécifique à cette carte, en utilisant un préfixe paramétrable via "data.prefix".
	 *
	 * @param suffix l'id de l'élément, par exemple "-cXXX" pour les client ou "" pour la map
	 * @return le préfixe, par défaut "themap", concaténé au suffixe donné, formant un id unique dans la page
	 */
	function getInternalId(suffix) {
		return (data.prefix || "themap") + suffix;
	}

	/**
	 * Cette méthode parcourt "data.customers" à la recherche des clients dans la zone rectangulaire
	 * délimitée par ses sommets opposés (x1, y1) et (x2, y2)
	 *
	 * @param x1 bord gauche de la selection rectangulaire
	 * @param x2 bord droit de la selection rectangulaire
	 * @param y1 bord bas de la selection rectangulaire
	 * @param y2 bord haut de la selection rectangulaire
	 * @return une liste client correspondant a la zone donnée (vide si rien n'a pas été trouvé)
	 */
	function getCustomersByXY(x1, x2, y1, y2) {
		if (data.onshowcustomer === false) {
			//si on ne veut pas afficher les clients, on s'arrête là
			return [];
		}
		if (typeof data.onshowcustomer === 'function') {
			// si on ne veut afficher que quelques clients, on les 'filtre' avec la fonction onshowcustomer
			return data.customers.filter(function(c) {
				return c.x >= x1 && c.x <= x2 && c.y >= y1 && c.y <= y2 && data.onshowcustomer(c);
			});
		}
		//si on veut afficher tous les clients
		return data.customers.filter(function(c) {
			return c.x >= x1 && c.x <= x2 && c.y >= y1 && c.y <= y2;
		});
	}

	/**
	 * Crée un fragment d'URL du type nom1=valeur1(&nom2=valeur2)*
	 *
	 * @param params un objet contenant les paramètres à concaténer
	 */
	function asUrlParams(params) {
		var p, v, result = '';
		for (p in params) {
			v = params[p];
			if (typeof v !== 'undefined') {
				if (result)
					result = result + '&';
				result = result + p + "=" + encodeURI(v);
			}
		}
		return result;
	}

	/**
	 * Crée un fragment d'HTML du type <tag attr1="value1" ... style="style1: value1; ...">html</tag>
	 *
	 * @param tag le noml du tag à générer
	 * @param attrs un objet contenant les attributs à générer pour le tag
	 * @param styles un objet contenant les propriétés CSS à générer dans le style
	 * @param html un contenu facultatif pour le tag
	 */
	function asHTMLElement(tag, attrs, styles, html) {
		var p, s = '<' + tag;
		for (p in attrs) {
			s += ' ' + p + '="' + attrs[p] + '"';
		}
		s += ' style="';
		for (p in styles) {
			s += p + ': ' + styles[p] + '; ';
		}
		if (html)
			s += '">' + html + '</' + tag + '>';
		else
			s += '" />';
		return s;
	}

	/**
	 * Retourne la couleur demandée sous forme HTML :
	 * - asHTMLColor(0, 1) renvoie rgb(0,0,0)
	 * - asHTMLColor(255, 0.5) renvoie rgba(255,0,0,0.5)
	 *
	 * @param intColor la couleur RGB (par exemple 0 pour noir)
	 * @param opacity valeur entre 0 (invisible) et 1 (opaque) pour jouer sur la transparence
	 * @return la couleur correspondante en HTML (par exemple #000000 pour noir ou rgba(r,g,b,opacity)
	 */
	function asHTMLColor(intColor, opacity) {
		var r = intColor >> 16 & 255, g = intColor >> 8 & 255, b = intColor & 255;
		if (opacity === 1)
			return 'rgb(' + r + ',' + g + ',' + b + ')';
		return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
	}

	/** Retourne la hauteur des images clients pour le niveau de zoom donné.
	 * Le temps qu'on a pas réupéré la définition des niveaux de zoom, on retourne 24 en dur */
	function gisScaleObjectsSizeInPixels(scaleIndex) {
		return data.scales[scaleIndex].objectsSizeInPixels;
	}

	/** Retourne le facteur de conversion d'une distance en pixel pour le niveau de zoom donné.
	 * Le temps qu'on a pas réupéré la définition des niveaux de zoom, on retourne le calcul équivalent */
	function gisScaleFactorToPixels(scaleIndex) {
		return data.scales[scaleIndex].factorToPixels;
	}

	/** Transforme une distance en pixels en une distance réelle dans la carte (inverse de gisScaleLengthToPixels) */
	function gisScalePixelsToLength(pixels, scaleIndex) {
		return pixels / gisScaleFactorToPixels(scaleIndex);
	}

	/** Transforme une distance réelle dans la carte en une distance en pixels (inverse de gisScalePixelsToLength) */
	function gisScaleLengthToPixels(length, scaleIndex) {
		return length * gisScaleFactorToPixels(scaleIndex);
	}

	/** Transforme une abscisse réelle dans la carte en une position relative en pixel */
	function gisScaleXToPixels(input, x, w, scaleIndex) {
		return Math.round(w / 2 + gisScaleLengthToPixels(input - x, scaleIndex));
	}

	/** Transforme une ordonnée réelle dans la carte en une position relative en pixel */
	function gisScaleYToPixels(input, y, h, scaleIndex) {
		return Math.round(h / 2 + gisScaleLengthToPixels(input - y, scaleIndex));
	}

	/** Dessine les fonds de carte */
	function updateBackground() {
		// Contiendra les img des fond de carte
		var backgroundContainer = element.children('.background').html(''),
			// Définition du niveau de zoom actuel
			scale = data.scales[data.scaleIndex],
			// Largeur de la carte en pixels
			w = Math.round(element.outerWidth()),
			// Hauteur de la carte en pixels
			h = Math.round(element.outerHeight()),
			xi, x1, x2, yi, y1, y2;

		// Ne pas afficher la carte, on peut s'arrêter là
		if (!getMapVisible(w, h))
			return;

		for (xi = 0; xi < scale.imageCountX; xi++) {
			x1 = gisScaleXToPixels(scale.x1 + (scale.x2 - scale.x1) * xi / scale.imageCountX, data.x, w, data.scaleIndex);
			if (x1 >= w)
				break;
			x2 = gisScaleXToPixels(scale.x1 + (scale.x2 - scale.x1) * (xi + 1) / scale.imageCountX, data.x, w, data.scaleIndex);
			if (x2 < 0)
				continue;

			for (yi = 0; yi < scale.imageCountY; yi++) {
				y1 = gisScaleYToPixels(scale.y1 + (scale.y2 - scale.y1) * yi / scale.imageCountY, data.y, h, data.scaleIndex);
				if (y1 >= h)
					break;
				y2 = gisScaleYToPixels(scale.y1 + (scale.y2 - scale.y1) * (yi + 1) / scale.imageCountY, data.y, h, data.scaleIndex);
				if (y2 < 0)
					continue;

				$('<img />')
					.attr('src', data.backgroundUrl + asUrlParams({
						x: xi + 1,
						y: scale.imageCountY - yi,
						scaleIndex: data.scaleIndex
					}))
					.css('left', x1 + 'px')
					.css('top', y1 + 'px')
					.css('width', (x2 - x1) + 'px')
					.css('height', (y2 - y1) + 'px')
					.appendTo(backgroundContainer);
			}
		}
	}

	/** Dessine les zones */
	function updateZones() {
		// Contiendra les img (contours) et/ou div (nom) des zones
		var zonesContainer = element.children('.zones').html(''),
			// Contiendra les area (cliquables) des zones
			mapContainer = element.children('.foreground').children('map'),
			// Largeur de la carte en pixels
			w = Math.round(element.outerWidth()),
			// Hauteur de la carte en pixels
			h = Math.round(element.outerHeight()),
			// Pour les perfs, on va contruire l'HTML pour tout insérer en une fois
			zonesHTML = '',
			mapFragment = document.createDocumentFragment(),
			// Pour les navigateurs qui supportent les canvas, on dessine les zones colorées plutôt que d'ajouter plein d'images
			canvas = $('<canvas />').attr('width', w).attr('height', h),
			// canvasContext qui sera "undefined" si les canvas ne sont pas supportés
			canvasContext = canvas[0].getContext ? canvas[0].getContext("2d") : undefined,
			i, j, zone, x, y, coords, visible;

		mapContainer.find('area.zone').remove();

		// Ne pas afficher les zones, on peut s'arrêter là
		if (data.onshowzone === false || !getMapVisible(w, h))
			return;

		var allZones = data.zones.concat(data.customerZones);
		for (i = 0; i < allZones.length; i++) {
			zone = allZones[i];

			// Pour choisir quelles zones afficher
			if ((typeof data.onshowzone === 'function') && !data.onshowzone(zone))
				continue;
			// Pour personnaliser l'affichage des zones (zones affichées uniquement)
			if (data.oncustomizezone)
				data.oncustomizezone(zone);

			// Calcule des coordonnées HTML du polygone de la zone
			coords = '';
			visible = false;
			for (j = 0; j < zone.pointCount; j++) {
				if (j > 0)
					coords += ',';
				x = gisScaleXToPixels(zone.xpoints[j], data.x, w, data.scaleIndex);
				y = gisScaleYToPixels(zone.ypoints[j], data.y, h, data.scaleIndex);
				coords += x + ',' + y;
				visible = visible || (x > 0 && x < w && y > 0 && y < h);
			}

			if (!visible)
				continue;

			if (data.useCanvas && canvasContext) {
				// Le dessin des zones dans un canvas plutôt que d'ajouter plein d'images pour les zones
				if (zone.color)
					canvasContext.fillStyle = asHTMLColor(zone.color, zone.opacity || data.zoneOpacity);
				if (zone.borderColor)
					canvasContext.strokeStyle = asHTMLColor(zone.borderColor, 1);
				canvasContext.lineWidth = (zone.borderWidth || 2);
				canvasContext.beginPath();
				for (j = 0; j < zone.pointCount; j++) {
					x = gisScaleXToPixels(zone.xpoints[j], data.x, w, data.scaleIndex);
					y = gisScaleYToPixels(zone.ypoints[j], data.y, h, data.scaleIndex);
					if (j === 0) {
						canvasContext.moveTo(x, y);
					} else {
						canvasContext.lineTo(x, y);
					}
				}
				if (zone.color) {
					canvasContext.fill();
				} else {
					if (!zone.shape || zone.shape === 'POLYG')
						canvasContext.closePath();
					canvasContext.stroke();
				}
			} else {
				// L'image de la zone dans le cas où les canvas ne sont pas supportés
				zonesHTML += asHTMLElement('img', {
					src: data.zoneImageUrl + asUrlParams({
						w: w,
						h: h,
						color: zone.color ? zone.color : undefined,
						borderColor: zone.borderColor ? zone.borderColor : undefined,
						borderWidth: zone.borderWidth || 2,
						caption: zone.caption ? zone.caption : undefined,
						shape: zone.shape ? zone.shape : undefined,
						points: coords
					}),
					alt: '',
					onerror: '$(this).remove();',
				}, {
					opacity: '' + (zone.opacity || data.zoneOpacity)
				});
			}

			// La zone cliquable pour les zones liées aux clients uniquement
			if (zone.type && data.scaleIndex >= data.showMapAreasScaleIndex) {
				mapFragment.appendChild($('<area class="zone" nohref="nohref" shape="poly" />').attr({
					'title': zone.type,
					'coords': coords
				}).data('zone', zone)[0]);
			}
		}
		zonesContainer.append(zonesHTML);
		zonesContainer.prepend(canvas);
		mapContainer[0].appendChild(mapFragment);
	}

	/** Dessine les étiquettes */
	function updateLabels() {
		// Contiendra les div des étiquettes
		var labelsContainer = element.children('.labels').html(''),
			// Largeur de la carte en pixels
			w = Math.round(element.outerWidth()),
			// Hauteur de la carte en pixels
			h = Math.round(element.outerHeight()),
			// Pour les perfs, on va contruire l'HTML pour tout insérer en une fois
			labelsHTML = '',
			// Pour les navigateurs qui supportent les canvas, on dessine les étiquettes plutôt que d'ajouter plein de div
			canvas = $('<canvas />').attr('width', w).attr('height', h),
			// canvasContext qui sera "undefined" si les canvas ne sont pas supportés
			canvasContext = canvas[0].getContext ? canvas[0].getContext("2d") : undefined,
			i, label, x, y, textWidth, textHeight, visible;

		// Ne pas afficher les étiquettes, on peut s'arrêter là
		if (data.onshowlabel === false || data.scaleIndex < data.showLabelsScaleInde || !getMapVisible(w, h))
			return;

		for (i = 0; i < data.labels.length; i++) {
			label = data.labels[i];

			// Pour choisir quelles étiquettes afficher
			if ((typeof data.onshowlabel === 'function') && !data.onshowlabel(label))
				continue;
			// Pour personnaliser l'affichage des étiquettes (étiquettes affichées uniquement)
			if (data.oncustomizelabel)
				data.oncustomizelabel(label);

			// Calcule des coordonnées HTML du point
			x = gisScaleXToPixels(label.x, data.x, w, data.scaleIndex);
			y = gisScaleYToPixels(label.y, data.y, h, data.scaleIndex);
			visible = (x > 0 && x < w && y > 0 && y < h);
			if (!visible)
				continue;

			if (data.useCanvas && canvasContext)  {
				// Le dessin des étiquettes dans un canvas plutôt que d'ajouter plein d'images pour les étiquettes
				canvasContext.font = (label.fontSize || 12) + 'px Arial';
				textHeight = label.fontSize || 12;
				textWidth = canvasContext.measureText(label.caption).width;
				// Le fond
				canvasContext.fillStyle = label.color ? asHTMLColor(label.color, 1) : '#FFFFFF';
				canvasContext.fillRect(x - textWidth / 2 - 5, y - textHeight / 2 - 2, textWidth + 10, textHeight + 6);
				// Le texte
				canvasContext.fillStyle = label.fontColor ? asHTMLColor(label.fontColor, 1) : '#000000';
				canvasContext.lineWidth = 1;
				canvasContext.fillText(label.caption, x - textWidth / 2, y + textHeight / 2 - 2);
				// Le bord
				canvasContext.strokeStyle = label.borderColor ? asHTMLColor(label.borderColor, 1) : '#000000';
				canvasContext.lineWidth = 2;
				canvasContext.strokeRect(x - textWidth / 2 - 5, y - textHeight / 2 - 2, textWidth + 10, textHeight + 6);
			} else {
				// Le texte de l'étiquette (avec fond et bord) dans un div (pour l'alignement)
				labelsHTML += asHTMLElement('div', {}, {
					'left': (x - 200) + 'px',
					'top': (y - (label.fontSize ? label.fontSize / 2 : 6) - 2/*padding*/ - 2/*border*/) + 'px',
				}, asHTMLElement('span', {}, {
					'background-color': label.color ? asHTMLColor(label.color, 1) : 'default',
					'border-color': label.borderColor ? asHTMLColor(label.borderColor, 1) : 'default',
					'color': label.fontColor ? asHTMLColor(label.fontColor, 1) : 'default',
					'font-size': label.fontSize ? (label.fontSize + 'px') : 'default',
					'line-height': label.fontSize ? (label.fontSize + 'px') : 'default'
				}, label.caption));
			}
		}
		labelsContainer.append(labelsHTML);
		labelsContainer.prepend(canvas);
	}

	/** Dessine les clients (et leur zone cliquables dans la map) */
	function updateCustomers() {
		// Contiendra les img/canvas (logo) et div (nom) des clients
		var customersContainer = element.children('.customers').html(''),
			// Contiendra les area (cliquables) des clients
			mapContainer = element.children('.foreground').children('map'),
			// Largeur de la carte en pixels
			w = Math.round(element.outerWidth()),
			// Hauteur de la carte en pixels
			h = Math.round(element.outerHeight()),
			// Pour les perfs, on va contruire l'HTML pour tout insérer en une fois
			customersHTML = '',
			mapFragment = document.createDocumentFragment(),
			// Pour les navigateurs qui supportent les canvas, on dessine les pastilles colorées plutôt que d'ajouter plein d'images
			canvas = $('<canvas />').attr('width', w).attr('height', h),
			// canvasContext qui sera "undefined" si les canvas ne sont pas supportés
			canvasContext = canvas[0].getContext ? canvas[0].getContext("2d") : undefined,
			i, customer, size, cx, cy, done, color, src;

		// Ne pas afficher les clients, on peut s'arrêter là
		if (data.onshowcustomer === false || !getMapVisible(w, h))
			return;

		for (i = 0; i < data.customers.length; i++) {
			customer = data.customers[i];
			var ele, eleCustomerAreaId = getInternalId('-c' + customer.code);

			// Pour choisir quels clients afficher (peut être "true" ou une fonction retournant true/false)
			if ((typeof data.onshowcustomer === 'function') && !data.onshowcustomer(customer)) {
				// On supprime le "area" car le client ne doit pas être affiché
				ele = document.getElementById(eleCustomerAreaId);
				if (ele != null)
					ele.parentNode.removeChild(ele);
				continue;
			}
			// Pour personnaliser l'affichage des clients (clients affichés uniquement)
			if (data.oncustomizecustomer)
				data.oncustomizecustomer(customer);

			// Calcul de la position du client : un rectangle allant de (cx,cy) à (cx+w,cy+h)
			size = gisScaleObjectsSizeInPixels(data.scaleIndex);
			cx = Math.round(gisScaleXToPixels(customer.x, data.x, w, data.scaleIndex) - size / 2);
			cy = Math.round(gisScaleYToPixels(customer.y, data.y, h, data.scaleIndex) - size / 2);

			// Zapper les clients hors champ
			if (cx < 0 || cx > w || cy < 0 || cy > h) {
				// On supprime le "area" car le client est hors cadre.
				 ele = document.getElementById(eleCustomerAreaId);
				if (ele != null)
					ele.parentNode.removeChild(ele);
				continue;
			}

			// Le logo du client
			done = false;
			if (data.useCanvas && canvasContext) {
				if (customer.color)
					color = asHTMLColor(customer.color, 1);
				else if (data.scaleIndex < data.showObjectImagesScaleIndex)
					color = '#000000';
				else
					color = undefined;
				if (color) {
					canvasContext.fillStyle = color;
					canvasContext.beginPath();
					canvasContext.arc(cx + size / 2, cy + size / 2, size / 2, 0, 2 * Math.PI);
					canvasContext.fill();
					done = true;
				}
				if (data.selectedCustomerCodes.indexOf(customer.code) >= 0) {
					canvasContext.strokeStyle = '#000000';
					canvasContext.lineWidth = 3;
					canvasContext.beginPath();
					canvasContext.moveTo(cx - 3, cy + size + 3);
					canvasContext.lineTo(cx + size + 3, cy + size + 3);
					canvasContext.stroke();
				}
			}
			if (! done) {
				// Si on zoom assez ou si le canvas n'est pas supporté, on utilise des images
				if (customer.imageUrl)
					src = customer.imageUrl;
				else
					src = data.customerImageUrl + asUrlParams({
						scaleIndex: data.scaleIndex,
						color: customer.color || (data.scaleIndex < data.showObjectImagesScaleIndex ? 0 : undefined),
						name: (!customer.color && data.scaleIndex >= data.showObjectImagesScaleIndex) ? customer.image1 : undefined
					});

				customersHTML += asHTMLElement('img', {
					src: src,
					alt: '',
					onerror: '$(this).remove();',
					onload: 'autoPositionImage(this);',
				}, {
					visibility: 'hidden',
					left: cx + 'px',
					top: cy + 'px',
					width: size + 'px',
					height: size + 'px'
				});
			}

			// Le libellé du client, si le zoom est suffisant
			if (data.scaleIndex >= data.showObjectCaptionsScaleIndex) {
				customersHTML += asHTMLElement('div', {}, {
					left: (cx + size / 2 - 200) + 'px',
					top: (cy + size + 2) + 'px'
				}, customer.caption || customer.code);
			}

			// La zone cliquable pour le client
			if (data.scaleIndex >= data.showMapAreasScaleIndex) {
				ele = document.getElementById(eleCustomerAreaId);
				if (ele == null) {
					mapFragment.appendChild($('<area class="customer" nohref="nohref" shape="rect" />').attr({
						'id': eleCustomerAreaId,
						'title': customer.caption || customer.code,
						'coords': '' + cx + ',' + cy + ',' + (cx + size) + ',' + (cy + size)
					}).data('customer', customer)[0]);
				} else {
					ele.coords =  '' + cx + ',' + cy + ',' + (cx + size) + ',' + (cy + size);
					ele.title = customer.caption || customer.code;
				}
			}
		}
		customersContainer.append(customersHTML);
		customersContainer.prepend(canvas);

		// On insère les "area.customer" avant les "area.zone" pour que, étrangement, elles apparaissent au-dessus
		mapContainer = mapContainer[0];
		if (mapContainer.childElementCount)
			mapContainer.insertBefore(mapFragment, mapContainer.childNodes[0]);
		else
			mapContainer.appendChild(mapFragment);
	}

	/** Dessine la zone devant avec les décorations */
	function updateForeground() {
		// Ne pas afficher la carte, on peut s'arrêter là
		var w = Math.round(element.outerWidth());
		var h = Math.round(element.outerHeight());
		if (!getMapVisible(w, h))
			return;
		// Le paramètre indiquant la légende est de la forme nom1,couleur1,nom2,couleur2,...
		var legend;
		if (data.showLegend) {
			// L'utilisateur peut spécifier une légende complémentaire en dur (comme les jour de la semaine dans l'agenda)
			legend = data.extraLegend.join(',');
			// En plus, on ajoute la légende pour les zones affichées, d'où le fait qu'on attende d'avoir les zones
			for (var i = 0; i < data.customerZones.length; i++) {
				var zone = data.customerZones[i];
				if (legend)
					legend += ',';
				legend += zone.type + ',' + (zone.color || zone.borderColor);
			}
		}
		// On recharge l'image de devant, en la cachant jusqu'à ce qu'elle soit chargée par esthétisme
		var img = element.children('.foreground').children('img'),
			src = data.foregroundUrl + asUrlParams({
				scaleIndex: data.scaleIndex,
				x: data.x,
				y: data.y,
				w: w,
				h: h,
				showZoom: data.showZoom,
				showScale: data.showScale,
				showPosition: data.showPosition,
				legend: legend
			});
		if (src !== img.attr('src'))
			img.attr('src', src);
	}

	/**
	 * C'est la fonction principale qui redessine la carte. Cette fonction est
	 * appelée automatiquement quand on scrolle, quand on se déplace ou quand on
	 * clique sur les éléments. Elle peut aussi être appelée manuellement par
	 * <code>$('#map').gis('update');</code>
	 * NB : quand la taille de carte change, il faut par contre appeler
	 * <code>$('#map').gis('resize');</code>
	 */
	function update() {
		// Vider le contenu dès maintenant
		element.children('.background').replaceWith('<div class="background" />');
		element.children('.zones').replaceWith('<div class="zones" />');
		element.children('.labels').replaceWith('<div class="labels" />');
		element.children('.customers').replaceWith('<div class="customers" />');
		element.children('.foreground').children('map').replaceWith('<map name="' + getInternalId('') +'" id="' + getInternalId('') + '" />');

		// Dessiner les fonds de carte
		updateBackground();
		// Dessiner les zones (zones clients ou zones fixes)
		updateZones();
		// Dessiner les étiquettes
		updateLabels();
		// Dessiner les clients
		updateCustomers();
		// Maintenant qu'on a les zones, on a la légende complète donc on peut dessiner la couche supérieure
		updateForeground();
	}

	/**
	 * Cette fonction zoome d'un niveau en gardant la même position et raffraichit ensuite le dessin
	 */
	function zoomIn() {
		data.scaleIndex = Math.min(data.scaleIndex + 1, data.scales.length - 1);
		update();
	}

	/**
	 * Cette fonction dézoome d'un niveau en gardant la même position et raffraichit ensuite le dessin
	 */
	function zoomOut() {
		data.scaleIndex = Math.max(data.scaleIndex - 1, 0);
		update();
	}

	/**
	 * Cette méthode déplace la carte sur le point d'abscisse "x".
	 * Depuis le 18/07/2018, on vérifie les coordonnées avec "data.bounds" pour ne pas partir trop loin (ex: carte blanche)
	 */
	function positionX(x) {
		data.x = Math.round(x);
		if (data.x > data.bounds.xMax)
			data.x = data.bounds.xMax;
		if (data.x < data.bounds.xMin)
			data.x = data.bounds.xMin;
	}

	/**
	 * Cette méthode déplace la carte sur le point d'ordonnée "y".
	 * Depuis le 18/07/2018, on vérifie les coordonnées avec "data.bounds" pour ne pas partir trop loin (ex: carte blanche)
	 */
	function positionY(y) {
		data.y = Math.round(y);
		if (data.y > data.bounds.yMax)
			data.y = data.bounds.yMax;
		if (data.y < data.bounds.yMin)
			data.y = data.bounds.yMin;
	}

	/**
	 * C'est une fonction qui centre la carte sur le contenu réel et ajuste le
	 * zoom au mieux pour ce contenu. Elle est appelée automatiquement sur le
	 * "dblclick" et peut être appelée manuellement par un code similaire à
	 * <code>$('#map').gis('adjust');</code>
	 */
	function adjust() {
		var adjustParams = getAdjustParams();
		adjustPosition(true, adjustParams);
		adjustZoom(false, adjustParams);
	}

	/**
	 * Cette fonction retourne les coordonnées minimale et maximale des point X et Y
	 * afin d'avoir les coordonnées de la zones contenant tous les magasins voulus
	 * et si il y a des magasins visibles
	 */
	function getAdjustParams() {
		// Récupérer les X/Y min/max pour trouver à la fin le centre
		var minx = 5000000,
			miny = 5000000,
			maxx = -5000000,
			maxy = -5000000;

		var visibleCustomers = false;
		var customer;
		for (var i = 0; i < data.customers.length; i++) {
			customer = data.customers[i];
			// On ne prend que les clients affichés si l'affichage est partiel. Sinon, on prend tout.
			if ((typeof data.onshowcustomer === 'function') && !data.onshowcustomer(customer))
				continue;
			minx = Math.min(minx, customer.x);
			miny = Math.min(miny, customer.y);
			maxx = Math.max(maxx, customer.x);
			maxy = Math.max(maxy, customer.y);
			visibleCustomers = true;
		}
		return {minx: minx, miny: miny, maxx: maxx, maxy: maxy, visibleCustomers: visibleCustomers};
	}

	/**
	 * C'est une fonction qui se positionne sur le centre du contenu de la carte
	 * peut être appelée manuellement par un code similaire à
	 * <code>$('#map').gis('adjustPosition');</code>
	 */
	function adjustPosition(skipUpdate, adjustParamsOrNull) {

		if(! adjustParamsOrNull) {
			adjustParamsOrNull = getAdjustParams();
		}
		//Si on n'a pas de client visible, on n'ajuste pas
		if(! adjustParamsOrNull.visibleCustomers)
			return;
		// Positionner au centre
		positionX((adjustParamsOrNull.minx + adjustParamsOrNull.maxx) / 2);
		positionY((adjustParamsOrNull.miny + adjustParamsOrNull.maxy) / 2);

		if (!skipUpdate)
			update();
	}

	/**
	 * C'est une fonction qui se ajuste le zoom en fonction des données dans la zones voulues
	 * peut être appelée manuellement par un code similaire à
	 * <code>$('#map').gis('adjustZoom(true/false)');</code>
	 */
	function adjustZoom(skipUpdate, adjustParamsOrNull) {
		if(! adjustParamsOrNull) {
			adjustParamsOrNull = getAdjustParams();
		}

		// Zoomer au maximum
		data.scaleIndex = data.scales.length - 1;
		// Récupérer la taille actuelle
		var pw = Math.round(element.outerWidth());
		var ph = Math.round(element.outerHeight());
		// Puis dézoomer jusqu'à ce que tous les clients soient visibles
		var hasAll;
		do {
			var w = gisScalePixelsToLength(pw, data.scaleIndex);
			var h = gisScalePixelsToLength(ph, data.scaleIndex);
			var x1 = data.x - Math.round(w / 2);
			var x2 = data.x + Math.round(w / 2);
			var y1 = data.y - Math.round(h / 2);
			var y2 = data.y + Math.round(h / 2);
			hasAll = true;
			if (x1 > adjustParamsOrNull.minx || x2 < adjustParamsOrNull.maxx || y1 > adjustParamsOrNull.miny || y2 < adjustParamsOrNull.maxy) {
				data.scaleIndex--;
				hasAll = false;
			}
		} while (data.scaleIndex > 0 && !hasAll);

		if (!skipUpdate)
			update();
	}

	/**
	 * Cette fonction dézoome d'un niveau en gardant la même position et raffraichit ensuite le dessin
	 */
	function toggleMultiSelectMode() {
		data.multiselectmode = !data.multiselectmode;
	}

	/**
	 * <p>
	 * Cette fonction est appelée quand la taille de la carte a changée.
	 * </p>
	 *
	 * <p>
	 * Malheureusement, Javascript ne permet pas de détecter un changement de
	 * taille d'une div quelconque mais uniquement sur "window". Comme l'un
	 * n'est pas lié à l'autre, la méthode n'est donc pas appelée
	 * automatiquement mais uniquement à la demande.
	 * </p>
	 *
	 * <p>
	 * Par exemple, si un redimensionnement de "window" implique un
	 * redimensionnement de la carte, on utilisera par exemple le code :
	 * </p>
	 *
	 * <code>
	 * $(window).resize(function() {
	 *   $('#map').gis('resize');
	 * });
	 * </code>
	 */
	function resize() {
		// Ajuster la taille du div qui a remplacé la carte quand elle est passée en "absolu"
		element.next().css('width', element.outerWidth() + 'px').css('height', element.outerHeight() + 'px');

		// Redessiner la carte
		update();
	}

	/**
	 * Cette fonction est appelée quand on crée la carte la première fois :
	 * <ul>
	 * <li>modification du div + création d'un div à la place</li>
	 * <li>création des div pour les couches de la carte (fond, zone, client, dessus)</li>
	 * <li>premier affichage de la carte</li>
	 * <li>mise en place des listener pour les interactions</li>
	 * </ul>
	 */
	function init() {
		// Mettre un div à la place car le div de la carte va passer en position absolue
		// C'est pour cela qu'il faut prévenir la carte si la taille change (pour éviter un timer)
		$('<div class="gis-placeholder" style="display: block;" />').css('width', element.outerWidth() + 'px').css('height', element.outerHeight() + 'px').insertAfter(element);

		// Position le style CSS pour la carte, les sous-div et le contenu de chaque sous-div
		element.addClass('gis');
		element.empty();
		element.append('<div class="background" />');
		element.append('<div class="zones" />');
		element.append('<div class="labels" />');
		element.append('<div class="customers" />');
		element.append('<div class="foreground"><img usemap="#' + getInternalId('') + '" /><map name="' + getInternalId('') + '" id="' + getInternalId('') + '" /></div>');

		// Premier affichage de la carte
		// Pas d'ajustement au contenu ici : on respecte le "x", "y" et "scaleIndex" passés en paramètres.
		// Si besoin, l'appelant peut utiliser "onready" pour demander un ajustement de la position et/ou du zoom.
		update();

		// Détecter les évènements 'resize' sur window pour ajuster la taille, si c'est demandé
		// Le timeout est utilisé pour ne pas redessiner pendant le "resize"
		// - les évènements "resize" sont ignorés tant qu'un autre évènement "resize" est envoyé juste après
		// - quand l'utilisateur arrête de bouger, on redessine enfin la carte à la nouvelle taille
		var resizeTimeout;
		if (data.createListenWindowResize) {
			$(window).resize(function() {
				if (resizeTimeout)
					clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(function() { resize(); resizeTimeout = undefined; }, 300);
			});
		}

		// Empêcher la sélection d'image même si la carte n'est pas interactive
		// Attention : le mousedown sur les area ne doit pas être annulé car il sert au clic sur les clients/zones
		element.on('vmousedown', ':not(area)', function(event) {
			event.preventDefault();
		});

		// Si l'utilisateur demande une carte non interactive (= figée), on peut s'arrêter là
		if (! data.createInteractive)
			return;

		// Zoom +/- avec la molette
		element.on('wheel mousewheel', function wheel(event) {
			// Ne pas scroller dans le document
			event.preventDefault();

			// Recupérer le décallage (>0 = vers le haut = zoom +)
			var delta;
			if (event.originalEvent.deltaY)
				delta = - event.originalEvent.deltaY;
			else if (event.originalEvent.wheelDelta)
				delta = event.originalEvent.wheelDelta;
			else if (event.originalEvent.detail)
				delta = - event.originalEvent.detail;
			if (!delta || (delta > 0 && data.scaleIndex === 8) || (delta < 0 && data.scaleIndex === 0))
				return;

			// Le point sous la souris doit rester fixe, on cherche quelques infos sur les positions
			var offset = element.offset();
			var centerX = offset.left - $(document).scrollLeft() + element.outerWidth() / 2;
			var centerY = offset.top - $(document).scrollTop() + element.outerHeight() / 2;
			var offsetX = event.originalEvent.clientX - centerX;
			var offsetY = event.originalEvent.clientY - centerY;

			if (delta > 0) {
				// Zoom + : augmenter scaleIndex et garder le point sous la souris fixe
				positionX(data.x + gisScalePixelsToLength(offsetX, data.scaleIndex) / 2);
				positionY(data.y + gisScalePixelsToLength(offsetY, data.scaleIndex) / 2);
				data.scaleIndex = Math.min(data.scaleIndex + 1, 8);
			} else {
				// Zoom - : diminuer scaleIndex et garder le point sous la souris fixe
				positionX(data.x - gisScalePixelsToLength(offsetX, data.scaleIndex));
				positionY(data.y - gisScalePixelsToLength(offsetY, data.scaleIndex));
				data.scaleIndex = Math.max(data.scaleIndex - 1, 0);
			}
			// Redessiner la carte
			update();
		});

		// clique droit sur la carte efface la selection des clients
		element.on('contextmenu', function() {
			data.selectedCustomerCodes = [];
			// On prévient le listener en lui filant les codes sélectionnés
			if (data.onselectcustomer)
				data.onselectcustomer(data.selectedCustomerCodes);
			// On redessine les clients
			updateCustomers();
			return false;
		});

		// Zoom +/- avec les doigts
		// Pour gérer le redimensionnement, on passe par 3 étapes :
		// - touchstart à 2 doigts pour trouver les positions initiales
		// - touchmove à 2 doigts pour suivre les doigts
		// - touchend à 0 doigt pour signifier la fin -> on zoom alors en fonction des positions précédemment obtenues
		element.on('touchstart', function(event) {
			var t = event.originalEvent.touches;
			function getDistance(x1, x2, y1, y2) {
				return Math.round(Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2)));
			}

			if (t && t.length === 2) {
				event.preventDefault();
				var x = (t[0].clientX + t[1].clientX) / 2;
				var y = (t[0].clientY + t[1].clientY) / 2;
				var startDistance = getDistance(t[0].clientX, t[1].clientX, t[0].clientY, t[1].clientY);
				var endDistance;

				//console.log('touchstart', startDistance, 'clientX', x, 'clientY', y);

				// On n'arrête d'écouter les "vmouse*" dès qu'on commence un "touch" à 2 doigts
				element.off('vmousemove').off('vmouseup');

				// On commence par contre à écouter les "touchmove" et "touchend"
				element.off('touchmove').on('touchmove', function(event) {
					t = event.originalEvent.touches;
					if (t && t.length === 2) {
						event.preventDefault();
						endDistance = getDistance(t[0].clientX, t[1].clientX, t[0].clientY, t[1].clientY);
					}

				}).off('touchend').on('touchend', function(event) {
					t = event.originalEvent.touches;
					if (t && t.length === 0 && startDistance && endDistance) {
						event.preventDefault();
						element.off('touchmove').off('touchend');

						// On se positionne sur le point visé par le zoom
						var offset = element.offset();
						var centerX = offset.left - $(document).scrollLeft() + element.outerWidth() / 2;
						var centerY = offset.top - $(document).scrollTop() + element.outerHeight() / 2;
						positionX(data.x + gisScalePixelsToLength(x - centerX, data.scaleIndex));
						positionY(data.y + gisScalePixelsToLength(y - centerY, data.scaleIndex));

						//console.log('touchend', endDistance, 'data.x', data.x, 'data.y', data.y);

						if (endDistance > startDistance + 70) {
							// Zoom + : augmenter scaleIndex
							data.scaleIndex = Math.min(data.scaleIndex + Math.round((endDistance - startDistance) / 70), 8);
							// Redessiner la carte
							update();

						} else if (endDistance < startDistance - 70) {
							// Zoom - : diminuer scaleIndex
							data.scaleIndex = Math.max(data.scaleIndex - Math.round((startDistance - endDistance) / 70), 0);
							// Redessiner la carte
							update();
						}
					}
				});
			}
		});

		// Détecter le mousedown qui lance un déplacement dans la carte par Drag/Drop
		// Les évènements "vmousedown", "vmousemove" et "vmouseup" sont simulés par jQuery Mobile :
		// - "vmousedown" est un "mousedown" ou un "touchstart"
		// - "vmousemove" est un "mousemove" ou un "touchmove"
		// - "vmouseup" est un "mouseup" ou un "touchend"
		element.on('vmousedown', function(event) {
			//console.log('mousedown', event.originalEvent.type, 'x', event.clientX, 'y', event.clientY, event.target);

			// On zappe le déplacement ou la sélection par glisser/déposer à la souris
			// si  l'utilisateur vient de presser un client (cf is('area.customer'))
			// et que l'appelant souhaite gérer le drag de client (cf data.ondragcustomer)
			if (data.ondragcustomer && $(event.target).is('area.customer'))
				return;

			// Position au moment du "mousedown", que l'on garde jusqu'au "mouseup"
			var startX = event.clientX;
			var startY = event.clientY;

			// Si un listener "multiselect" est positionné, Ctrl+DnD permet de multi-sélectionner des clients
			if (event.ctrlKey || data.multiselectmode) {
				// Plus besoin d'écouter les anciens "vmousemove" et "vmouseup"
				element.off('vmousemove').off('vmouseup');

				// On affiche alors un rectangle en pointillés autour de la zone délimitée
				var offset = element.offset();
				var div = $('<div class="selection" />').appendTo(element);
				var moved = false;
				$(document).on('mousemove', function(event) {
					// On met à jour le rectangle en pointillés autour de la zone sélectionnée
					moved = true;
					div.css('left', Math.floor(Math.min(startX, event.clientX) - offset.left) + 'px')
						.css('width', Math.floor(Math.abs(event.clientX - startX)) + 'px')
						.css('top', Math.floor(Math.min(startY, event.clientY) - offset.top) + 'px')
						.css('height', Math.floor(Math.abs(event.clientY - startY)) + 'px');

				}).on('mouseup', function(event) {
					// On arrête les listeners
					$(document).off('mousemove').off('mouseup');
					// On retire le rectangle en pointillés
					div.remove();

					if (!moved)
						return;

					// On transforme les coordonnées du rectangle en coordonnées dans la carte
					var offset = element.offset();
					var centerX = offset.left - $(document).scrollLeft() + element.outerWidth() / 2;
					var centerY = offset.top - $(document).scrollTop() + element.outerHeight() / 2;
					var x1 = Math.round(data.x + gisScalePixelsToLength(Math.min(startX, event.clientX) - centerX, data.scaleIndex));
					var x2 = Math.round(data.x + gisScalePixelsToLength(Math.max(startX, event.clientX) - centerX, data.scaleIndex));
					var y1 = Math.round(data.y + gisScalePixelsToLength(Math.min(startY, event.clientY) - centerY, data.scaleIndex));
					var y2 = Math.round(data.y + gisScalePixelsToLength(Math.max(startY, event.clientY) - centerY, data.scaleIndex));

					// On prépare la liste des codes sélectionnés
					data.selectedCustomerCodes = [];
					if (data.scaleIndex < data.showMapAreasScaleIndex) {
						var customers = getCustomersByXY(x1, x2, y1, y2);
						for(var i = 0; i < customers.length; i++)
							data.selectedCustomerCodes.push(customers[i].code);
					}
					else{
						element.find('area.customer').each(function() {
							var area = $(this),
								customer = area.data('customer'),
								code = customer.code,
								x = parseInt(customer.x),
								y = parseInt(customer.y);
							if (x >= x1 && x <= x2 && y >= y1 && y <= y2)
								data.selectedCustomerCodes.push(code);
						});
					}
					// On prévient le listener en lui filant les codes sélectionnés
					if (data.onselectcustomer)
						data.onselectcustomer(data.selectedCustomerCodes);
					// On redessine les clients
					updateCustomers();
				});
				return;
			}

			element.off('vmousemove').on('vmousemove', function() {
				//console.log('mousemove', event.originalEvent.type, 'x', event.clientX, 'y', event.clientY);

				// On note que la souris pour qu'au "mouseup", on sache si c'est un "drag" ou un "click"
				element.addClass('dragging');

			}).off('vmouseup').on('vmouseup', function(event) {
				//console.log('mouseup', event.originalEvent.type, 'x', event.clientX, 'y', event.clientY);

				// Plus besoin d'écouter "vmousemove" et "vmouseup" jusqu'au prochain "vmousedown"
				element.off('vmousemove').off('vmouseup');

				// Si la souris a bougé depuis la position initiale, c'est un "drag"
				if (element.is('.dragging')) {
					element.removeClass('dragging');
					// Calcul du décallage en pixels
					var offsetX = event.clientX - startX;
					var offsetY = event.clientY - startY;
					if (offsetX >= -10 && offsetX <= 10 && offsetY >= -10 && offsetY <= 10)
						return;
					// Calcul de la nouvel position réelle dans la carte
					positionX(data.x - gisScalePixelsToLength(offsetX, data.scaleIndex));
					positionY(data.y - gisScalePixelsToLength(offsetY, data.scaleIndex));
					// Redessiner la carte
					update();
				}
			});
		});

		// Double-cliquer pour ajuster au contenu, ou utiliser un code similaire à celui-ci :
		// $('#map').gis('adjust');
		element.on('dbltap', function(event) {
			//console.log('dbltap');
			adjust();
		});

		// Détecter le clic sur une zone
		// Les zones sont des "area" où l'on a stocké un type de zone, contrairement aux clients
		element.on('click', 'area.zone', function clickZone(event) {
			event.preventDefault(); // pour éviter le # dans l'URL
			var area = $(this),
				zone = area.data('zone'),
				code = zone.code,
				type = zone.type;
			if (data.onclickzone)
				data.onclickzone(code, type);
		});

		// Détecter le glisser/déposer d'un client
		// Les clients sont des "area" où l'on a stocké la position, contrairement aux zones
		element.on('touchstart mousedown', 'area.customer', function mousedownCustomer(event) {
			event.preventDefault(); // pour éviter le # dans l'URL
			if (data.ondragcustomer) {
				var area = $(this),
					title = area.attr('title'),
					customer = area.data('customer'),
					code = customer.code,
					image = customer.image1,
					x = parseInt(customer.x),
					y = parseInt(customer.y);
				data.ondragcustomer(title, code, image, x, y, event.clientX, event.clientY);
			}
		});
		element.on('touchend click', 'area.customer', function clickCustomer(event) {
			event.preventDefault(); // pour éviter le # dans l'URL
			var area = $(this),
				title = area.attr('title'),
				customer = area.data('customer'),
				code = customer.code,
				image = customer.image1,
				x = parseInt(customer.x),
				y = parseInt(customer.y);
			// Doit-on se déplacer sur le client et le sélectionner
			var proceed = true;
			// Possibilité d'enregistrer un listener pour être prévenu du clic
			if (data.onclickcustomer)
				// Appeler le listener qui annulera éventuellement le comportement par défaut
				proceed = data.onclickcustomer(title, code, image, x, y);
			// Si le comportement par défaut n'a pas été annulé ...
			if (proceed) {
				// On regarde si le client était sélectionné
				var selectionIndex = data.selectedCustomerCodes.indexOf(code),
					multiSelect = (data.multiselectmode || data.selectedCustomerCodes.length >= 2 || event.ctrlKey);

				if (selectionIndex >= 0) {
					// Désélection d'un client
					data.selectedCustomerCodes.splice(selectionIndex, 1);

				} else if (selectionIndex < 0 && multiSelect) {
					// Ajout du client à la sélection
					data.selectedCustomerCodes.push(code);

				} else if (selectionIndex < 0) {
					// Remplacer la sélection
					data.selectedCustomerCodes = [code];
					// Et on se déplace à sa position
					if (data.moveOnCustomerSelection) {
						positionX(x);
						positionY(y);
					}
				}

				// Prévenir que la sélection a changé
				if (data.onselectcustomer)
					data.onselectcustomer(data.selectedCustomerCodes);

				// Si on a juste besoin de redessiner les clients, tant mieux
				if (selectionIndex >= 0 || multiSelect || !data.moveOnCustomerSelection)
					updateCustomers();
				else
					// Mais si on se déplace, on doit redessiner la carte
					update();
			}
		});
	}

	function isReady() {
		return typeof data.scales !== 'undefined';
	}

	$.getJSON(data.scalesUrl, function(scales) {
		data.scales = scales;
		init();
		if (data.onready)
			data.onready();
	});

	return {
		isReady: isReady,
		update: update,
		updateZones: updateZones,
		updateLabels: updateLabels,
		updateCustomers: updateCustomers,
		zoomIn: zoomIn,
		zoomOut: zoomOut,
		adjust: adjust,
		adjustPosition: adjustPosition,
		adjustZoom: adjustZoom,
		toggleMultiSelectMode: toggleMultiSelectMode,
		resize: resize,
	};
} // Gis

/**
 * C'est un plugin jQuery qui transforme un div en une carte.
 * L'utilisation la plus simple est :
 *
 * <code>
 * var gisParams = {
 *   ...
 * };
 * $('#map').gis('init', gisParams);
 * </code>
 */
(function($) {

	/**
	 * Ici, c'est le plugin jQuery lui-même : c'est une fonction qui pourra être appliquée aux objets jQuery pour créer une carte.
	 *
	 * Le premier paramètre est l'action :
	 * <ul>
	 * <li>'init' : pour créer la carte et dessiner une première fois</li>
	 * <li>'update' : pour redessiner la carte</li>
	 * <li>'update*' : pour ne redessiner qu'une partie de la carte</li>
	 * <li>'adjust' : pour centrer la carte sur le contenu et redessiner</li>
	 * <li>'resize' : poru adapter la taille et redessiner (par exemple après une resize de la fenêtre)</li>
	 * </ul>
	 * Pour la méthode 'init', il faut un 2ème paramètre (objet) contenant :
	 * <ul>
	 * <li>les options de création (position et zoom initials, listener, options d'affichage, ...)</li>
	 * <li>les données partagée pendant l'utilisation (position, zoom, client sélectionné, ...)</li>
	 * </ul>
	 */
	$.fn.gis = function(action, userData) {

		var defaultData = {
			// true pour une carte est interactive (click, move, wheel), false pour une carte en lecture seule
			createInteractive: true,
			// true pour que la carte écoute les "resize" sur "window" et se redimensionne toute seule
			createListenWindowResize: true,
			// true pour utiliser les canvas, plus rapides que de multiples div/img
			useCanvas: true,
			// URL pour obtenir la définition des échelles
			scalesUrl: '/gis/scales',
			// URL pour obtenir les images de fond de carte (paramètres : x, y, scaleIndex)
			backgroundUrl: '/gis/background?',
			// URL pour la génération d'image de zones (paramètres : w, h, color, borderColor, borderWidth, caption, shape, points)
			zoneImageUrl: '/gis/zoneImage?',
			// URL pour la génération d'image de clients (paramètres : scaleIndex, color, name)
			customerImageUrl: '/gis/customerImage?',
			// URL pour générer l'image du dessus de la carte (paramètres : x, y, w, h, scaleIndex, showZoom, showScale, showPosition, legend)
			foregroundUrl: '/gis/foreground?',

			// Abscisse initiale pour mise à jour au fur et à mesure
			x: 633997,
			// Ordonnée initiale pour mise à jour au fur et à mesure
			y: -2152185,
			// Rectangle de coins opposés (x1, y1) et (x2, y2) délimitant la surface où l'on peut se positionner
			bounds: { xMin: 41000, xMax: 1216000, yMin: -2701000, yMax: -1578000 },
			// Zoom initial pour mis à jour au fur et à mesure
			scaleIndex: 0,
			// Affiche-t-on la vue dézoomée en haut à droite ?
			showZoom: false,
			// Affiche-t-on l'échelle en bas à droite ?
			showScale: true,
			// Affiche-t-on la légende en haut à gauche ?
			showLegend: true,
			// Affiche-t-on la position avec une croix en pointillés ?
			showPosition: false,
			// Niveau de zoom à partir duquel on crée les zones cliquables
			showMapAreasScaleIndex: 3,
			// Niveau de zoom à partir duquel on affiche les images (des points sinon)
			showObjectImagesScaleIndex: 3,
			// Niveau de zoom (0..8) à partir duquel on affiche le nom des clients (5 dans v1, désactivé dans v2)
			showObjectCaptionsScaleIndex: 9,
			// Niveau de zoom à partir duquel on affiche les étiquettes (inexistant dans SOLVNET 1)
			showLabelsScaleIndex: 3,
			// Pour choisir la transparence des zones (utiliser "oncustomizezone" pour choisir la transparence zone par zone)
			zoneOpacity: 0.3,
			// Pour personnaliser la légende avec des entrées supplémentaires (contient de toute façon la légende des zones)
			extraLegend: [],
			// Pas de zone fixe par défaut (shape, color, borderColor, borderWidth, pointCount, xpoints, ypoints, opacity, layer)
			zones: [],
			// Pas de zone client par défaut (shape, color, borderColor, borderWidth, pointCount, xpoints, ypoints, opacity, code, type)
			customerZones: [],
			// Pas d'étiquette par défaut (x, y, caption, color, borderColor, fontColor, fontSize)
			labels: [],
			// Pas de clients par défaut (x, y, code, caption, color, image1, image2, imageUrl)
			customers: [],
			// Le tableau de code clients actuellement sélectionnés, vide par défaut
			selectedCustomerCodes: [],
			// Indique si la carte se positionne sur le client sélectionné en cas de simple-sélection
			moveOnCustomerSelection: false,

			// Pour être prévenu une fois que la carto est prête
			/*
			onready: function() { ... },
			*/

			// Pour être prévenu quand la sélection de client(s) change
			/*
			onselectcustomer: function(customers) {
				//
			},
			*/

			// Pour sélection plusieurs client, on peut garder "Ctrl" appuyé ou activer "multiselectmode" à true
			/*
			multiselectmode: false,
			*/

			// Pour choisir quels clients afficher
			/*
			onshowcustomer: undefined, // tous les clients
			onshowcustomer: true, // tous les clients
			onshowcustomer: false, // aucun client
			onshowcustomer: function(customer) {
				return true; // true = show, false = hide
			},
			*/

			// Pour personnaliser l'affichage des clients (clients affichés uniquement)
			/*
			oncustomizecustomer: function(customer) {
				customer.color = rbg;
				customer.title = 'Un libellé au choix';
			},
			*/

			// Pour être prévenu quand on clique un client et éventuellement annuler le comportement par défaut
			/*
			onclickcustomer: function(title, code, image, x, y) {
				console.log('Clic sur le client "' + title + '" (' + code + ')');
				return true; // proceed = select and move
			},
			*/

			// Pour être prévenu quand on glisse un client (NB: par défaut, le glisser-déposer de client ne fait rien)
			/*
			ondragcustomer: function(title, code, image, x, y) {
				console.log('Glisser du client "' + title + '" (' + code + ')');
			},
			*/

			// Pour choisir quelles zones afficher
			/*
			onshowzone: undefined, // toutes les zones
			onshowzone: true, // toutes les zones
			onshowzone: false, // aucune zone
			onshowzone: function(zone) {
				return true; // true = show, false = hide
			},
			*/

			// Pour personnaliser l'affichage des zones (zones affichées uniquement)
			/*
			oncustomizezone: function(zone) {
				zone.color = rbg;
				zone.borderColor = 0;
				zone.type = 'Zone ' + zone.type;
				zone.opacity = 0.7;
			},
			*/

			// Pour être prévenu quand on clique une zone
			/*
			onclickzone: function(code, type) {
				console.log('Clic sur la zone ' + type + ' du client ' + code);
			},
			*/

			// Pour choisir quelles étiquettes afficher
			/*
			onshowlabel: undefined, // toutes les étiquettes
			onshowlabel: true, // toutes les étiquettes
			onshowlabel: false, // aucune étiquette
			onshowlabel: function(label) {
				return true; // true = show, false = hide
			},
			*/

			// Pour personnaliser l'affichage des zones (zones affichées uniquement)
			/*
			oncustomizelabel: function(label) {
				label.fontSize = 12;
				label.color = 255 << 16 | 255 << 8 | 255; //blanc
				label.fontColor = 0; //noir
				label.borderColor = 0; //noir
				label.caption = '...';
			},
			*/
		};

		// L'objet "userData" passé en paramètre devient un espace "partagé" entre le composant et l'utilisateur
		// pour que les modifications (position, zoom, ...) d'un côté puissent être comprises de l'autre.
		// - récupérer un objet contenant les propriétés par défaut, surchargées avec les propriétés de l'utilisateur
		var tmpData = $.extend({}, defaultData, userData);
		// - réinjecter tout ça dans l'objet fourni par l'utilisateur pour compléter avec les propriétés par défaut
		$.extend(userData, tmpData);

		// Comme préconisé pour les plugins jQuery, retourner "this" lui-même pour pouvoir chainer les appels
		// Par exemple $('#map').gis('init', data).on('mousedown mouseover mouseout', 'area.customer', function() {...});
		return this.each(function() {
			// Initialisation de la carte (lance une requête Ajax pour récupérer "scales")
			if (action === 'init')
				this.gis = new Gis($(this), userData);
			// On appelle l'action demandée uniquement si la carte est prête
			else if (this.gis.isReady())
				this.gis[action]();
		});
	};

})(window.jQuery);
